import { combineReducers } from "redux";
import account from "./reducers";

export default combineReducers({
  account,
});
